'use client';
import { Button } from '@curology/ui-components-web/react/Button';
import { Modal } from '@curology/ui-components-web/react/Modal';
import { ModalContent } from '@curology/ui-components-web/react/Modal/ModalContent';
import { ModalFooter } from '@curology/ui-components-web/react/Modal/ModalFooter';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { ModalContentRouter } from './components/ModalContentRouter';
import { useProductIngredientsModalState } from '../../hooks/useProductIngredientsModalState';

export const ProductIngredientsModal = () => {
  const { modalCard, dismissModal } = useProductIngredientsModalState();

  return (
    <Modal
      onClose={dismissModal}
      open={!!modalCard}
      title={
        modalCard?.modal.title && (
          <Typography className="cur-mt-1 cur-grow" size="h1">
            {modalCard.modal.title}
            {modalCard.modal.titleIsRx && <sup>Rx</sup>}
          </Typography>
        )
      }
      width={548}
    >
      {modalCard && (
        <ModalContent className="cur-bg-surface-neutral cur-p-4 cur-text-primary">
          <ModalContentRouter modalCard={modalCard} />
        </ModalContent>
      )}
      <ModalFooter>
        <Button
          className="cur-w-full"
          data-sentry-id="Close modal"
          onClick={dismissModal}
          size="lg"
          state="dark"
        >
          Done
        </Button>
      </ModalFooter>
    </Modal>
  );
};
